export const CLEAR_GROUP = 'app/Group/CLEAR_GROUP'
export const CLEAR_GROUP_CONTENT = 'app/Group/CLEAR_GROUP_CONTENT'

export const GET_GROUP = 'app/Group/GET_GROUP'
export const GET_GROUP_DONE = 'app/Group/GET_GROUP_DONE'
export const GET_GROUP_ERROR = 'app/Group/GET_GROUP_ERROR'

export const GET_GROUP_CONTENT = 'app/Group/GET_GROUP_CONTENT'
export const GET_INACTIVE_GROUP_CONTENT_DONE =
  'app/Group/GET_INACTIVE_GROUP_CONTENT_DONE'
export const GET_ALL_GROUP_CONTENT_DONE = 'app/Group/GET_ALL_GROUP_CONTENT_DONE'
export const GET_GROUP_CONTENT_DONE = 'app/Group/GET_GROUP_CONTENT_DONE'
export const GET_GROUP_CONTENT_ERROR = 'app/Group/GET_GROUP_CONTENT_ERROR'

export const UPDATE_PINS_BATCH = 'app/Group/UPDATE_PINS_BATCH'
export const UPDATE_PINS_BATCH_DONE = 'app/Group/UPDATE_PINS_BATCH_DONE'
export const UPDATE_PINS_BATCH_ERROR = 'app/Group/UPDATE_PINS_BATCH_ERROR'

export const UPDATE_GROUP = 'app/Group/UPDATE_GROUP'
export const UPDATE_GROUP_DONE = 'app/Group/UPDATE_GROUP_DONE'
export const UPDATE_GROUP_ERROR = 'app/Group/UPDATE_GROUP_ERROR'

export const REMOVE_PINS = 'app/Group/REMOVE_PINS'
export const REMOVE_PINS_DONE = 'app/Group/REMOVE_PINS_DONE'
export const REMOVE_PINS_ERROR = 'app/Group/REMOVE_PINS_ERROR'

export const DUPLICATE_GROUP = 'app/Group/DUPLICATE_GROUP'
export const DUPLICATE_GROUP_DONE = 'app/Group/DUPLICATE_GROUP_DONE'
export const DUPLICATE_GROUP_ERROR = 'app/Group/DUPLICATE_GROUP_ERROR'

// ADD_PINS_TO_GROUP
export const ADD_PINS_TO_GROUP = 'app/Group/ADD_PINS_TO_GROUP'
export const ADD_PINS_TO_GROUP_DONE = 'app/Group/ADD_PINS_TO_GROUP_DONE'
export const ADD_PINS_TO_GROUP_ERROR = 'app/Group/ADD_PINS_TO_GROUP_ERROR'

export const ADD_PINS_TO_GROUPS = 'app/Group/ADD_PINS_TO_GROUPS'

export const SORT_PINS = 'app/Group/SORT_PINS'
export const CHANGE_SEARCH = 'app/Group/CHANGE_SEARCH'
export const CHANGE_QUICK_FILTER = 'app/Group/CHANGE_QUICK_FILTER'
export const CHANGE_STATE_FILTER = 'app/Group/CHANGE_STATE_FILTER'
export const CHANGE_PAGE = 'app/Group/CHANGE_PAGE'
export const CHANGE_SIZE = 'app/Group/CHANGE_SIZE'

export const quickFilterOptions = {
  ALL_PINS: 'Any',
  CREATED_BY_ME: 'ByMe',
  CREATED_BY_OTHERS: 'ByOthers'
}

export const stateFilterOptions = {
  ALL: 'All',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive'
}
